export default (phoneNo, swap = '08to62') => {
  var phone = '';
  var pattern = /^0+/g;
  var pattern2 = /^(62)+/g;
  if (!phoneNo) return ''

  if (swap === '62to08') {
    if (phoneNo.match(pattern2)) {
      phone = phoneNo.replace(pattern2, '0');
    } else if (phoneNo.match(pattern)) {
      phone = phoneNo.replace(pattern, '0');;
    } else {
      phone = `0${phoneNo}`;
    }
  } else {
    if (phoneNo.match(pattern)) {
      phone = phoneNo.replace(pattern, '62');
    } else if (phoneNo.match(pattern2)) {
      phone = phoneNo.replace(pattern2, '62');
    } else {
      phone = `62${phoneNo}`;
    }
  }

  return phone;
};
